export const ModuleContext = 'context'
export const ModuleProduct = 'product'
export const DemoCRUD = 'demoCrud'
export const ModuleEnrollmentStudent = 'enrollmentStudent'
export const ModuleFile = 'file'
export const ModuleLocation = 'location'
export const ModuleParentCareer = 'parentCareer'
export const ModuleStudentDisability = 'studentDisability'
export const ModuleStudentPolicies = 'studentPolicies'
export const ModuleEthnic = 'ethnic'
export const ModuleEnrollmentGroup = 'enrollmentGroup'
export const ModuleEnrollmentProfile = 'enrollmentProfile'
export const ModuleAdditionService = 'additionService'
export const ModuleTenant = 'tenant'
export const ModulePost = 'post'
export const ModuleEnrollmentStudentAttachment = 'enrollmentStudentAttachment'
export const ModuleExport = 'exportPortal'

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
  ModuleContext,
  DemoCRUD,
  ModuleEnrollmentStudent,
  ModuleFile,
  ModuleLocation,
  ModuleParentCareer,
  ModuleStudentDisability,
  ModuleStudentPolicies,
  ModuleEthnic,
  ModuleEnrollmentGroup,
  ModuleEnrollmentProfile,
  ModuleTenant,
  ModulePost,
  ModuleExport,
]
